<template>
  <va-edit-layout>
    <person-form :id="id" :title="title" :item="item"></person-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
